import axios from 'axios';
import _ from 'lodash';

import BaseModel from './BaseModel';
import UserModel from './UserModel';
const BASE = BaseModel.getApiBasePath() + '/api/v1/roles';

export default new class RoleModel {

  get(id) {
    return new Promise((resolve, reject) => {
      this.getAll()
        .then((data) => {
          resolve(_.find(data, {id: id}));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getAll() {    
    return new Promise((resolve, reject) => {        
      axios.get(BASE, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
      .then((response) => {
        resolve(response.data);          
      })
      .catch((error) => {
        reject(error);
      });        
    });    
  }
  
}


// WEBPACK FOOTER //
// ./src/components/RoleModel.js